import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// Models
import { ScreenLoaderData } from 'src/app/platform/components/ui-screen-loader/ui-screen-loader.model';

// Services
import { UiService } from 'src/app/platform/services/ui.service';

@Component({
  selector: 'app-payments-status',
  templateUrl: './payments-status.component.html',
  styleUrls: ['./payments-status.component.scss']
})
export class PaymentsStatusComponent implements OnInit {
  public queryParams: any;
  public type = 'default';
  public types: any = {
    default: new ScreenLoaderData('Proceso de pago', 'No pudimos obtener el estado del pago, puede que se trate de un error de lectura. Desde el área Mis facturas podes consultar el estado de las mismas.', 'error_outline'),
    approved: new ScreenLoaderData('Pago acreditado', 'Tu pago fue acreditado correctamente, lo podras ver reflejado en la seccion de pagos.', 'done'),
    in_process: new ScreenLoaderData('Pago pendiente de acreditación', 'Tu pago se encuentra en proceso. Cuando finalice recibiras una notificacion por correo.Aun no realizaste ningún pago. Cuando realices un pago prodras verlo reflejado aqui.', 'schedule'),
    null: new ScreenLoaderData('Tu pago fue rechazado o lo cancelaste', 'No se proceso tu pago porque fue rechazado por el medio utilizado o porque cancelaste el proceso generado.', 'error_outline'),
    rejected: new ScreenLoaderData('Tu pago fue rechazado o lo cancelaste', 'No se proceso tu pago porque fue rechazado por el medio utilizado o porque cancelaste el proceso generado.', 'error_outline'),
  };

  constructor(
    private uiService: UiService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.type = params.status;
    });

    // collection_id=1238353660
    // collection_status=approved
    // payment_id=1238353660
    // status=approved
    // external_reference="crmNro":1736705,"clienteNro":1000895
    // payment_type=credit_card
    // merchant_order_id=2910778827
    // preference_id=783784502-4ba8491e-9d48-4ae2-b2eb-d2c509e923b5
    // site_id=MLA
    // processing_mode=aggregator
    // merchant_account_id=null

    if (typeof this.types[this.type] !== 'undefined') {
      this.uiService.screenLoaderSet(this.types[this.type]);
    } else {
      this.uiService.screenLoaderSet(this.types.default);
    }
  }
}
